import React, { useContext } from 'react'
import { useWindowSize } from '@olxbr/ds-web'
import { AlertCircle } from '@olxbr/ds-icons'
import { ResponsiveTooltip } from '../../atoms/ResponsiveTooltip/ResponsiveTooltip'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'

export const PersonalDataTooltip = () => {
  const { lurker } = useContext(RevalidationContext)
  const { isMobile } = useWindowSize()

  return (
    <ResponsiveTooltip
      width={238}
      text="Pedimos este dado para garantir ainda mais segurança na sua conta. Não se preocupe, a OLX não divulga dados pessoais."
    >
      <AlertCircle
        onClick={() => isMobile && lurker.viewMessageEvt('document_tooltip')}
        onMouseEnter={() => !isMobile && lurker.viewMessageEvt('document_tooltip')}
        color="var(--color-neutral-120)"
      />
    </ResponsiveTooltip>
  )
}
